import {
  createDraftPost as publicCreateDraftPost,
  bulkCreateDraftPosts as publicBulkCreateDraftPosts,
  bulkUpdateDraftPosts as publicBulkUpdateDraftPosts,
  listDeletedDraftPosts as publicListDeletedDraftPosts,
  getDraftPost as publicGetDraftPost,
  updateDraftPost as publicUpdateDraftPost,
  deleteDraftPost as publicDeleteDraftPost,
  removeFromTrashBin as publicRemoveFromTrashBin,
  bulkDeleteDraftPosts as publicBulkDeleteDraftPosts,
  listDraftPosts as publicListDraftPosts,
  getDeletedDraftPost as publicGetDeletedDraftPost,
  restoreFromTrashBin as publicRestoreFromTrashBin,
  queryDraftPosts as publicQueryDraftPosts,
  typedQueryDraftPosts as publicTypedQueryDraftPosts,
  publishDraftPost as publicPublishDraftPost,
} from './blog-v3-draft-draft-posts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  DraftPostQuery,
  DraftPostsQueryBuilder,
  QueryDraftPostsOptions,
  typedQueryDraftPosts as universalTypedQueryDraftPosts,
} from './blog-v3-draft-draft-posts.universal.js';
import { onDraftCreated as publicOnDraftCreated } from './blog-v3-draft-draft-posts.public.js';
import { onDraftDeleted as publicOnDraftDeleted } from './blog-v3-draft-draft-posts.public.js';
import { onDraftUpdated as publicOnDraftUpdated } from './blog-v3-draft-draft-posts.public.js';

function customQueryDraftPosts(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryDraftPostsOptions) =>
      publicQueryDraftPosts(httpClient)(options),
    typedQueryFunction: (
      query: DraftPostQuery,
      options?: QueryDraftPostsOptions
    ) => publicTypedQueryDraftPosts(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: DraftPostQuery,
    options?: QueryDraftPostsOptions
  ): ReturnType<typeof universalTypedQueryDraftPosts>;
  function overloadedQuery(
    options?: QueryDraftPostsOptions
  ): DraftPostsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: DraftPostQuery | QueryDraftPostsOptions,
    options?: QueryDraftPostsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicCreateDraftPost> & typeof publicCreateDraftPost
> = /*#__PURE__*/ createRESTModule(publicCreateDraftPost);
export const bulkCreateDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateDraftPosts> &
    typeof publicBulkCreateDraftPosts
> = /*#__PURE__*/ createRESTModule(publicBulkCreateDraftPosts);
export const bulkUpdateDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateDraftPosts> &
    typeof publicBulkUpdateDraftPosts
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateDraftPosts);
export const listDeletedDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicListDeletedDraftPosts> &
    typeof publicListDeletedDraftPosts
> = /*#__PURE__*/ createRESTModule(publicListDeletedDraftPosts);
export const getDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicGetDraftPost> & typeof publicGetDraftPost
> = /*#__PURE__*/ createRESTModule(publicGetDraftPost);
export const updateDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDraftPost> & typeof publicUpdateDraftPost
> = /*#__PURE__*/ createRESTModule(publicUpdateDraftPost);
export const deleteDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDraftPost> & typeof publicDeleteDraftPost
> = /*#__PURE__*/ createRESTModule(publicDeleteDraftPost);
export const removeFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRemoveFromTrashBin> &
    typeof publicRemoveFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRemoveFromTrashBin);
export const bulkDeleteDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteDraftPosts> &
    typeof publicBulkDeleteDraftPosts
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteDraftPosts);
export const listDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicListDraftPosts> & typeof publicListDraftPosts
> = /*#__PURE__*/ createRESTModule(publicListDraftPosts);
export const getDeletedDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicGetDeletedDraftPost> &
    typeof publicGetDeletedDraftPost
> = /*#__PURE__*/ createRESTModule(publicGetDeletedDraftPost);
export const restoreFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRestoreFromTrashBin> &
    typeof publicRestoreFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRestoreFromTrashBin);
export const publishDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicPublishDraftPost> &
    typeof publicPublishDraftPost
> = /*#__PURE__*/ createRESTModule(publicPublishDraftPost);
export const queryDraftPosts: MaybeContext<
  BuildRESTFunction<typeof customQueryDraftPosts> & typeof customQueryDraftPosts
> = /*#__PURE__*/ createRESTModule(customQueryDraftPosts);
/**
 * Triggered when a draft post is created.
 */
export const onDraftCreated: BuildEventDefinition<typeof publicOnDraftCreated> &
  typeof publicOnDraftCreated = createEventModule(publicOnDraftCreated);
/**
 * Triggered when a draft post is deleted.
 */
export const onDraftDeleted: BuildEventDefinition<typeof publicOnDraftDeleted> &
  typeof publicOnDraftDeleted = createEventModule(publicOnDraftDeleted);
/**
 * Triggered when a draft post is updated.
 */
export const onDraftUpdated: BuildEventDefinition<typeof publicOnDraftUpdated> &
  typeof publicOnDraftUpdated = createEventModule(publicOnDraftUpdated);

export {
  Origin,
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  BannerOrigin,
  LayoutDataBackgroundType,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  Status,
  ModerationStatusStatus,
  TotalDraftPostsGroupingField,
  WebhookIdentityType,
  Type,
  Field,
  Action,
  GetDraftPostsSort,
  SortOrder,
} from './blog-v3-draft-draft-posts.universal.js';
export {
  DraftPost,
  FocalPoint,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  V1Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  Banner,
  LayoutDataBackground,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  ModerationDetails,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  Media,
  MediaMediaOneOf,
  WixMedia,
  VideoResolution,
  EmbedMedia,
  EmbedThumbnail,
  EmbedVideo,
  DraftPostTranslation,
  DraftCategoriesUpdated,
  DraftTagsUpdated,
  GetDraftPostTotalsRequest,
  GetDraftPostTotalsResponse,
  TotalDraftPosts,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  InitialDraftPostsCopied,
  CreateDraftPostRequest,
  CreateDraftPostResponse,
  BulkCreateDraftPostsRequest,
  BulkCreateDraftPostsResponse,
  BulkDraftPostResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateDraftPostsRequest,
  MaskedDraftPosts,
  BulkUpdateDraftPostsResponse,
  DraftPostOwnerChanged,
  ListDeletedDraftPostsRequest,
  BlogPaging,
  ListDeletedDraftPostsResponse,
  PagingMetadataV2,
  Cursors,
  GetDraftPostRequest,
  GetDraftPostResponse,
  UpdateDraftPostContentRequest,
  UpdateDraftPostContentResponse,
  UpdateDraftPostRequest,
  UpdateDraftPostResponse,
  DeleteDraftPostRequest,
  DeleteDraftPostResponse,
  RemoveFromTrashBinRequest,
  RemoveFromTrashBinResponse,
  BulkDeleteDraftPostsRequest,
  BulkDeleteDraftPostsResponse,
  ListDraftPostsRequest,
  ListDraftPostsResponse,
  MetaData,
  GetDeletedDraftPostRequest,
  GetDeletedDraftPostResponse,
  RestoreFromTrashBinRequest,
  RestoreFromTrashBinResponse,
  QueryDraftPostsRequest,
  PlatformQuery,
  PlatformQueryPagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryDraftPostsResponse,
  PublishDraftPostRequest,
  PublishDraftPostResponse,
  UnpublishPostRequest,
  UnpublishPostResponse,
  GetDraftPostCountsRequest,
  GetDraftPostCountsResponse,
  DraftPostCount,
  TranslateDraftRequest,
  TranslateDraftResponse,
  IsDraftPostAutoTranslatableRequest,
  IsDraftPostAutoTranslatableResponse,
  UpdateDraftPostLanguageRequest,
  UpdateDraftPostLanguageResponse,
  BulkRevertToUnpublishedRequest,
  BulkRevertToUnpublishedResponse,
  BulkRejectDraftPostRequest,
  BulkRejectDraftPostResponse,
  RevertToUnpublishedRequest,
  RevertToUnpublishedResponse,
  RejectDraftPostRequest,
  RejectDraftPostResponse,
  ApproveDraftPostRequest,
  ApproveDraftPostResponse,
  MarkPostAsInModerationRequest,
  MarkPostAsInModerationResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  DraftCreatedEnvelope,
  DraftDeletedEnvelope,
  DraftUpdatedEnvelope,
  CreateDraftPostOptions,
  BulkCreateDraftPostsOptions,
  BulkUpdateDraftPostsOptions,
  ListDeletedDraftPostsOptions,
  GetDraftPostOptions,
  UpdateDraftPost,
  UpdateDraftPostOptions,
  DeleteDraftPostOptions,
  BulkDeleteDraftPostsOptions,
  ListDraftPostsOptions,
  QueryDraftPostsOptions,
  DraftPostsQueryResult,
  DraftPostsQueryBuilder,
  DraftPostQuerySpec,
} from './blog-v3-draft-draft-posts.universal.js';
export { utils } from './blog-v3-draft-draft-posts.universal.js';
export {
  OriginWithLiterals,
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  BannerOriginWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  StatusWithLiterals,
  ModerationStatusStatusWithLiterals,
  TotalDraftPostsGroupingFieldWithLiterals,
  WebhookIdentityTypeWithLiterals,
  TypeWithLiterals,
  FieldWithLiterals,
  ActionWithLiterals,
  GetDraftPostsSortWithLiterals,
  SortOrderWithLiterals,
  CommonQueryWithEntityContext,
  DraftPostQuery,
} from './blog-v3-draft-draft-posts.universal.js';
